import { useMemo } from 'react';

type Brand = 'pingwincasino' | 'million';
interface BrandTheme {
  brand: Brand;
  assets: {
    logo: {
      default: string;
      mobile: string;
    };
    loader: {
      default: string;
      mobile: string;
    };
    favicon: string;
  };
}

const BRAND_THEMES: Record<Brand, BrandTheme> = {
  pingwincasino: {
    brand: 'pingwincasino',
    assets: {
      logo: {
        default: '/images/brand/pingwincasino/desktop.svg',
        mobile: '/images/brand/pingwincasino/mobile.svg',
      },
         loader: {
          default: '/images/brand/pingwincasino/desktop-loader.svg',
          mobile: '/images/brand/pingwincasino/mobile-loader.svg',
         },
      favicon: '/images/brand/pingwincasino/favicon.ico',
    },
  },
  million: {
    brand: 'million',
    assets: {
      logo: {
        default: '/images/brand/million/desktop.svg',
        mobile: '/images/brand/million/mobile.svg',
      },
      loader: {
        default: '/images/brand/million/desktop-loader.svg',
        mobile: '/images/brand/million/mobile-loader.svg',
       },
      favicon: '/images/brand/million/favicon.ico',
    },
  },
};

const useBrandTheme = () => {
  const brandTheme = useMemo((): BrandTheme& {
    isMillion: boolean;
  } => {
    const currentHostname = window.location.hostname;
    const isMillion = currentHostname.includes('million');
    const selectedBrand = isMillion ? 'million' : 'pingwincasino';
    const cookieName = 'brand-selection';

    const cookieValue = `${cookieName}=${selectedBrand}; path=/; max-age=31536000; SameSite=Lax${
      window.location.protocol === 'https:' ? '; Secure' : ''
    }`;

    document.cookie = cookieValue;

    return {...BRAND_THEMES[selectedBrand],isMillion};
  }, []);

  return brandTheme;
};

export { useBrandTheme };
